<div *ngIf="params" class="advanced-table-header">
  <div class="customHeader" style="display: flex; align-items: center;">
    <!-- <div class="customHeaderMenuButton" (click)="onContextMenu($event)">
      <fa name="bars" class="bars"></fa>
    </div> -->
    <div class="customHeaderLabel" (click)="onSortRequested(this.sorted, $event)">{{params.displayName}}</div>
    <div *ngIf="params.enableSorting" [hidden]="this.sorted != 'desc'" class="{{'customSortDownLabel'+ (this.sorted === 'desc' ? ' active' : '') }}"
        (click)="onSortRequested('asc', $event)">
        <!-- <fa name="long-arrow-up" class="long-arrow-up"></fa> -->
        <fa name="sort-alpha-desc" class="sort-alpha-desc"></fa>
    </div>
    <div *ngIf="params.enableSorting" [hidden]="this.sorted != 'asc'" class="{{'customSortUpLabel'+ (this.sorted === 'asc' ? ' active' : '') }}"
        (click)="onSortRequested('desc', $event)">
        <!-- <fa name="long-arrow-down" class="long-arrow-down"></fa> -->
        <fa name="sort-alpha-asc" class="sort-alpha-asc"></fa>
    </div>
    <!-- <div [hidden]="!params.enableSorting" class="{{'customSortRemoveLabel'+ (this.sorted === '' ? ' active' : '') }}"
        (click)="onSortRequested('', $event)">
        <i class="fa fa-times"></i>
    </div> -->
  </div>
</div>
<context-menu [useBootstrap4]="true" (close)="onCloseContextMenu()">
  <ng-template contextMenuItem passive="true">
    <div class="custom-filter">
      <!-- <p class="filter-title">Filter by column : </p> -->
      <mat-form-field style="font-size: 13px;">
        <input matInput class="custom-input-search" type="text" placeholder="Enter text to filter" [(ngModel)]="filter" (ngModelChange)="input(filter)" autocomplete="off">
      </mat-form-field>
    </div>
  </ng-template>
</context-menu>